<section>
  <div class="my-2">
    <form [formGroup]="formInventoryTransferDetail">
      <div class="row p-1">
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <app-custom-inputgroup [inputValue]="codeNameArticle" [labelText]="'Artículo'"
            [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Artículo'" [required]="true"
            [recovery]="true" (onClick)="openArticleSelectionModal()"></app-custom-inputgroup>
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Artículos Disponible'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal [value]="rentalStockForm" [labelText]="'Existencia'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Q.Alm.'"
            (onChangeNumber)="changeQuantity($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-4 d-flex align-items-end mt-2 gap-2">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'success'"
            (onClick)="send()"></app-custom-button>
          <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'"
            (onClick)="clearForm()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>